{
  "Clear search": "清除搜尋條件"
}
